import { ButtonComponent } from './button/button';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule } from '@angular/core';
import { DerryBrothers } from '../app/app.component';
import { GoogleMapComponent } from './googlemap/googlemap';
import { IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SettingsIconComponent } from './settings-icon/settings-icon';
import { StatusMessageComponent } from './status-message/status-message';
import { HeaderComponent } from './header/header';
import { BackButtonComponent } from './back-button/back-button';
import { ItemGroupComponent } from './item-group/item-group';
import { TabbedUiComponent } from './tabbed-ui/tabbed-ui';

@NgModule({
	declarations: [
	    ButtonComponent,
        GoogleMapComponent,
        SettingsIconComponent,
        StatusMessageComponent,
        HeaderComponent,
        BackButtonComponent,
        ItemGroupComponent,
        TabbedUiComponent,
    ],
	imports: [
        BrowserModule,
        CommonModule,
        IonicModule.forRoot(DerryBrothers),
    ],
	exports: [
	    ButtonComponent,
        GoogleMapComponent,
        SettingsIconComponent,
        StatusMessageComponent,
        HeaderComponent,
        BackButtonComponent,
        ItemGroupComponent,
        TabbedUiComponent,
    ],
    providers: [
        { provide: ErrorHandler, useClass: IonicErrorHandler }
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
    ]
})
export class ComponentsModule {}



// WEBPACK FOOTER //
// ./src/components/components.module.ts